<template>
    <a :href="to"
       :class="{
         active: isActive
       }"
       v-scroll-to="{
        el: '#'+element,
        container: '#scrollBar',
        duration: 800,
        onDone: onDone
        }"
        @click="checkEl()"
    >
        <slot></slot>
    </a>
</template>

<script>
    import Vue from 'vue';
    import VueScrollTo from 'vue-scrollto';

    Vue.use(VueScrollTo);

    export default {
        name: 'route-item',
        data(){
          return {
              toOtherPage: false
          }
        },
        props: {
            to: {
                type: [String],
                required: false,
                default: '/'
            },
            element: {
                type: [String],
                required: false,
                default: 'index'
            }
        },
        computed: {
            isActive() {
                return this.$route.path === this.to;
            }
        },
        methods: {
            onDone() {

            },
            checkEl() {
                if(document.getElementById('#'+this.element)!== null){

                } else {
                    this.$router.push(this.to);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// routeItem.vue?090d4259